import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { EditPostDialogComponent } from '../edit-post-dialog/edit-post-dialog.component';
import { InsightsDialogComponent } from '../insights-dialog/insights-dialog.component';

@Component({
  selector: 'app-feed-options-dialog',
  templateUrl: './feed-options-dialog.component.html',
  styleUrls: ['./feed-options-dialog.component.css']
})
export class FeedOptionsDialogComponent implements OnInit {

  postDetails;

  constructor(
    public dialogRef: MatDialogRef<FeedOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService
  ) { }

  ngOnInit(): void {
    this.getPostById();
  }

  getPostById() {
    this.service.getPostById(this?.data).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.postDetails = res.data
        } else if (res.errorCode != 0) {
          if (res.data.data.length == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      }
    )

  }

  dismiss() {
    this.dialogRef.close(null);
  }

  deleteMyPost() {
    this.service.deleteMyPost(this?.postDetails?.postId).subscribe(
      res => {
        if (res.errorCode == 0) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.success("Deleted Successfully");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.success("تم الحذف");
          }
          this.dialogRef.close("delete");
        } else if (res.errorCode != 0) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.error("Something went wrong");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.error("حدث خطأ ما");
          }
        }
      }
    )
  }

  pinPostAndUnpin() {
    if (!this?.postDetails?.iPinnedPost) {
      this.service.pinPost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Pinned Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم التثبيت");
            }
            this.dialogRef.close(null);
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (this?.postDetails?.iPinnedPost) {
      this.service.unpinPost(this?.postDetails?.postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Unpinned Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم إلغاء التثبيت");
            }
            this.dialogRef.close(null);
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  chartPopUp(id) {
    // let id = this?.data
    const dialogRef = this.dialog.open(InsightsDialogComponent, {
      width: '700px',
      data: { id },
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {

      }
    });
  }

  editPost() {
    const dialogRef = this.dialog.open(EditPostDialogComponent, {
      width: '33%',
      data: this?.postDetails?.postId
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == "edit") {
        this.dialogRef.close("edit");
      }
    });
  }

}
